import { Injectable } from '@angular/core';
import { BehaviorSubject }    from 'rxjs/BehaviorSubject';

@Injectable()

export class BondMathComponentService {
  
  constructor() {
    console.log("construct BMCS");
  }
  // Observable string sources
  private showLiabilities = new BehaviorSubject<boolean>(false);
  // Observable string streams
  ShowLiabilities$ = this.showLiabilities.asObservable();
  
  public resetService() {
    console.log("bondmathComponent.service : resetService");
  }

  public SwitchView(isLiability:boolean) {
    console.log("GCS StartGame " + isLiability);
    this.showLiabilities.next(isLiability);
  }
}


// WEBPACK FOOTER //
// ./src/app/bondmath/bondmathComponent.service.ts